module.exports = __webpack_public_path__ + "img/mbBanner23.b7f19a28.png";